import { LayingPatternViewer } from 'CommonScripts/layingPatternViewer';
import { ZipService } from 'CommonData/services/zip.service';
import { LoadingHelper } from 'CommonScripts/loadingHelper';

export class Tools {
    private static applyPBRBtn: HTMLButtonElement = document.querySelector('.js-apply-pbr');
    private static getPBRBtn: HTMLButtonElement = document.querySelector('.js-get-pbr');
    private static stopRendererBtn: HTMLButtonElement = document.querySelector('.js-stop-renderer');
    private static materialTextureKeyInp: HTMLInputElement = document.querySelector('.js-tools-texture-key');
    private static jointTextureKeyInp: HTMLInputElement = document.querySelector('.js-tools-joint-key');
    private static rendererIsStopped: boolean = false;

    public static init() {
        this.initEvents();
    }

    private static initEvents() {
        this.applyPBRBtn?.addEventListener('click', () => {
            this.applyPBR();
        });

        this.getPBRBtn?.addEventListener('click', () => {
            this.getPBR();
        });

        this.stopRendererBtn?.addEventListener('click', () => {
            this.stopStartRenderer();
        });
    }

    private static stopStartRenderer() {
        let btnText = "Stop";

        if (this.rendererIsStopped) {
            LayingPatternViewer.startRenderer();
        }
        else {
            LayingPatternViewer.stopRenderer();
            btnText = "Start";
        }

        this.rendererIsStopped = !this.rendererIsStopped;
        this.stopRendererBtn.innerText = btnText;
    }

    private static async applyPBR() {
        const materialTextureKeyInput = this.materialTextureKeyInp?.value;

        // example Joint Texture Key 5_tile-grout-white_1_197
        const jointTextureKeyInput = this.jointTextureKeyInp?.value;

        if (materialTextureKeyInput && jointTextureKeyInput) {
            LoadingHelper.start();

            try {
                const jointProps: Array<string> = jointTextureKeyInput.split("_");
                const jointWidthMM: number = parseInt(jointProps[0]);
                const jointTextureKey: string = jointProps[1];
                const maskId: number = parseInt(jointProps[2]);
                const patternId: number = parseInt(jointProps[3]);
                const materialTextureKey: string = materialTextureKeyInput;

                await LayingPatternViewer.updateTextureOverride(materialTextureKey, jointTextureKey, jointWidthMM, maskId, patternId);
            }
            catch {
                console.log('Custom Texture Application Failed');
            }
            finally {
                LoadingHelper.stop();
            }
        }
    }

    private static async getPBR() {
        LoadingHelper.start();

        try {
            const currentTextureObject: any = LayingPatternViewer.getCurrentTexture();
            const diffuseUrl: string =
                `https://media.marshalls.co.uk/image/upload/VisualiserMaterials/Textures_Jointing/${currentTextureObject.ProductTextureKey}/${currentTextureObject.JointWidthMM}_${currentTextureObject.JointTextureKey}_${currentTextureObject.MaskId}_${currentTextureObject.PatternId}_diffuse_med.jpg`;
            const normalUrl: string = diffuseUrl.replace("_diffuse_med.jpg", "_normal_med.png");
            const roughnessUrl: string = diffuseUrl.replace("_diffuse_", "_roughness_");

            await ZipService.downloadAndZip(new Array<string>(diffuseUrl, normalUrl, roughnessUrl));
        } finally {
            LoadingHelper.stop();
        }
    }
}